var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { memo } from 'react';
import { Button } from '../../../Button/Button';
import { getInvestmentUsefulDataFromType } from './utils';
import { DetailsModal } from '../DetailsModal';
import { Table } from '../../../Table';


export function buildInvestmentDetailsTableData(investments) {
    var tableDataRows = [];
    investments.map(function (investment) {
        var usefulInvestmentData = getInvestmentUsefulDataFromType(investment).map(function (_a) {
            var data = _a.data;
            return data;
        });
        tableDataRows.push(__spreadArrays(usefulInvestmentData, [
            React.createElement(DetailsModal, { trigger: React.createElement(Button, { size: "small", link: true }, "Veja detalhes"), investment: investment }),
        ]));
    });
    return tableDataRows;
}
var InvestmentDetails = function (_a) {
    var investments = _a.investments;
    // note: all investments have same type so we take the first one as reference
    var investmentsHeaders = getInvestmentUsefulDataFromType(investments[0]);
    var headers = __spreadArrays(investmentsHeaders.map(function (investmentHeader) { return investmentHeader.header; }), [
        // adding empty string to have an empty column to match the design (intentional empty)
        '',
    ]);
    var dataRows = buildInvestmentDetailsTableData(investments);
    return (React.createElement(Table, { headers: headers, rows: dataRows, className: 'InvestmentDetails pluggy' }));
};
export default memo(InvestmentDetails);
